import moment from 'moment'
import { Notification } from 'element-ui'

export const notifySuccess = (message) => {
  return Notification({
    title: '成功',
    message: message,
    duration: 3000,
    type: 'success'
  })
}

export const formatDate = ({ date, layout, format = 'YYYY-MM-DD, HH:mm:ss' } = {}) => {
  if (!date) {
    return ''
  }
  const normalizedDate = moment(date, layout)
  if (!normalizedDate.isValid()) {
    return ''
  }
  if (format === 'object') {
    return normalizedDate.toDate()
  }
  return normalizedDate.format(format)
}

export const deleteEmptyKey = (obj) => {
  if (!(obj instanceof Object)) {
    throw new Error('参数必须为对象')
  }
  let data = Object.assign({}, obj)
  for (let key in data) {
    if (!data[key]) {
      delete data[key]
    }
  }
  return data
}
